define(["require", "exports", "@mindbreeze/client-web-components"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
});
